import {
  FeatureName,
  useCandidateSummaryPositionPermissionsQuery,
} from "../../../graphql";
import { useHasFeatureAccess } from "../../../hooks/useHasFeatureAccess";

export const useCanViewCandidateSummary = (
  positionId: string | null
): {
  summariesEnabled: boolean;
  canViewSummaries: boolean;
  loading: boolean;
} => {
  const summariesEnabled = useHasFeatureAccess(FeatureName.CandidateAiSummary);
  const { data: permissions, loading } =
    useCandidateSummaryPositionPermissionsQuery({
      skip: !summariesEnabled,
      variables: {
        positionId,
      },
    });
  const canViewSummaries = Boolean(
    permissions?.candidateSummaryPositionPermissions?.canViewSummaries
  );

  return {
    summariesEnabled,
    canViewSummaries,
    loading,
  };
};
